import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '../views/Login/Login.vue'
import Login from '../views/Login/Login.vue'
// import Register from '../views/Login/Register.vue'
import store from "@/store";
// import Layout from '../layout/layout'


Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/pre',
  //   redirect: '/pre/witPpy',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       name: '智慧社区',
  //       path: '/pre/witPpy',
  //       component: () => import('../views/witPpy.vue')
  //     }
  //   ]
  // },
  // {
  //   path: '/pre/Login',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       name: '登录',
  //       path: '/pre/Login',
  //       component: Login
  //     }
  //   ]
  // },
  // {
  //   path: '/pre/Register',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       name: '注册',
  //       path: '/pre/Register',
  //       component: Register
  //     }
  //   ]
  // },
  {
    path: '/login',
    name: '登录',
    component: Login
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404/404.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../views/Pay/Pay.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 提供一个重置路由的方法
export const resetRouter = () => {
  router.matcher = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
}


// 注意：刷新页面会导致页面路由重置
export const setRoutes = () => {
  // const storeMenus = localStorage.getItem("menus");
  const storeMenus = JSON.stringify([
      {
          children: [{node: "102001", displayText: "用户管理", pictureIndex: "el-icon-user", tabText: "/Admin/User"}],
          display: "block", displayText: "管理操作", node: "102",parentNode: "1", pictureIndex: "el-icon-menu"
      },
      {
          children: [],
          display: "block", displayText: "门锁列表", node: "103",parentNode: "1", pictureIndex: "el-icon-lock", tabText: "/Lock/Lock"
      },
      {
          children: [],
          display: "block", displayText: "分组列表", node: "104",parentNode: "1", pictureIndex: "el-icon-lock", tabText: "/Group/Group"
      },
  ]);
  localStorage.setItem("menus", storeMenus)
  if (storeMenus) {

    // 获取当前的路由对象名称数组
    const currentRouteNames = router.getRoutes().map(v => v.name)
    if (!currentRouteNames.includes('Manage')) {
      // 拼装动态路由
      const manageRoute = { path: '/Index', name: 'Index', component: () => import('../views/Layout/Index.vue'), redirect: "/home", children: [
          // { path: 'person', name: '个人信息', component: () => import('../components/Person/Index.vue')},
          // { path: '/Admin/User', name: '用户管理', component: () => import('../views/Layout/Main/Admin/User.vue')},
        ] }
      // const manageRoute = {
      //   path:"/person",
      //   component: ()=>import('../components/Person/Index.vue'),
      // }
      const menus = JSON.parse(storeMenus)
      menus.forEach(item => {
        // console.log(menus);
        if (item.tabText) {  // 当且仅当path不为空的时候才去设置路由   item.path.replace("/", "")
          let itemMenu = { path: item.tabText, name: item.displayText, component: () => import('../views/Layout/Main' + item.tabText + '.vue')}
          // console.log(itemMenu);
          manageRoute.children.push(itemMenu)
        } else if(Array.isArray(item.children)) {
          item.children.forEach(item => {
            if (item.tabText) {
              // item.path.replace("/", "")
              let itemMenu = { path: item.tabText, name: item.displayText, component: () => import('../views/Layout/Main' + item.tabText + '.vue')}
              // console.log(itemMenu);
              manageRoute.children.push(itemMenu)
            }
          })
        }
      })
      // console.log(manageRoute)
      // 动态添加到现在的路由对象中去
      router.addRoute(manageRoute)
    }

  }
}

// 重置我就再set一次路由
setRoutes()


// 路由守卫
// 路由守卫
// 路由守卫
router.beforeEach(async(to, from, next) => {
  localStorage.setItem("currentPathName", to.name)  // 设置当前的路由名称
  store.commit("setPath")

  // 未找到路由的情况
  if (!to.matched.length) {

    next("/login")
    // if (storeMenus) {
    //   next("/pre")
    // } else {
    //   // 跳回登录页面
    //   next("/pre")
    // }
  }
  // 其他的情况都放行
  // resetRouter() // 重置路由
  
  next()

})

export default router
